import Buttons from "../../../components/UI/Buttons";

const MissingClaim=(props)=>{
    return(
        <>
        <div class="col-md-4 col-12 mb-2 pb-1">
          <div class="card mb-0 border-0 shadow-none h-100">
            <div class="card-header sh_accordionheader">
              <div class="d-flex justify-content-between align-items-center">
                <h6 class="text-md font-weight-bold mb-0"> Missing Claim Numbers </h6>
                <div>
                  <a class="btn btn-light sh_btnlight">View Report</a>
                </div>
              </div>
            </div>
            <div class="card-body p-2">
              <div class="d-flex  align-items-center h-100 w-100">
                <div class="sh_animatedpiechartcontainer w-50">
                  <svg id="animatedPieChartSvg" width="140" height="140" viewBox="0 0 136 136">
                    <circle class="bg" cx="68" cy="68" r="65" stroke="#f2f2f2" stroke-width="10" fill="none"></circle>

                    <circle id="pieSeg1" class="sh_animatedpiechartsegment" cx="68" cy="68" r="65" stroke="#7D4BC5" stroke-width="10" fill="none" stroke-dasharray="204.20352248333654 204.20352248333654" stroke-dashoffset="0" stroke-linecap="square"></circle>
                    <circle id="pieSeg2" class="sh_animatedpiechartsegment" cx="68" cy="68" r="65" stroke="#0EA472" stroke-width="10" fill="none" stroke-dasharray="81.68140899333463 326.72563597333846" stroke-dashoffset="-204.20352248333654" stroke-linecap="square"></circle>
                    <circle id="pieSeg3" class="sh_animatedpiechartsegment" cx="68" cy="68" r="65" stroke="#C1B8B7" stroke-width="10" fill="none" stroke-dasharray="61.26105674500096 347.14598822167216" stroke-dashoffset="-285.88493147667117" stroke-linecap="square"></circle>
                    <circle id="pieSeg4" class="sh_animatedpiechartsegment" cx="68" cy="68" r="65" stroke="#EA634A" stroke-width="10" fill="none" stroke-dasharray="61.26105674500096 347.14598822167216" stroke-dashoffset="-347.14598822167216" stroke-linecap="square"></circle>
                  </svg>
                  <div class="sh_animatedpietotalcontainer">
                    <p class="p3-light text-dark mb-0">Total</p>
                    <h3 class="p1-strong mb-0">1400</h3>
                  </div>
                </div>
                <div class="d-flex flex-column  w-50">

                  <div class="d-flex justify-content-between">
                    <p class="p3-light text-dark mb-1">
                      <span class="mr-1">
                        <svg width="12" height="13" viewBox="0 0 12 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <rect y="0.5" width="12" height="12" rx="6" fill="#EA634A"></rect>
                        </svg>
                      </span>
                      Total Missing Claims</p>
                    <p class="p3-light text-dark mb-1">200</p>
                  </div>
                  <div class="d-flex justify-content-between">
                    <p class="p3-light text-dark mb-1">
                      <span class="mr-1">
                        <svg width="12" height="13" viewBox="0 0 12 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <rect y="0.5" width="12" height="12" rx="6" fill="#7D4BC5"></rect>
                        </svg>
                      </span>
                      Completed</p>
                    <p class="p3-light text-dark mb-1">750</p>
                  </div>
                  <div class="d-flex justify-content-between">
                    <p class="p3-light text-dark mb-1">
                      <span class="mr-1">
                        <svg width="12" height="13" viewBox="0 0 12 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <rect y="0.5" width="12" height="12" rx="6" fill="#0EA472"></rect>
                        </svg>
                      </span>
                      Passed</p>
                    <p class="p3-light text-dark mb-1">300</p>
                  </div>
                  <div class="d-flex justify-content-between">
                    <p class="p3-light text-dark mb-1">
                      <span class="mr-1">
                        <svg width="12" height="13" viewBox="0 0 12 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <rect y=" 0.5" width="12" height="12" rx="6" fill="#C1B8B7"></rect>
                        </svg>
                      </span>
                      Failed</p>
                    <p class="p3-light text-dark mb-1">150</p>
                  </div>

                </div>
              </div>
            </div>
          </div>
        </div>
        </>
    );
}
export default MissingClaim;